import React from "react";
import {
  TextField,
  PrimaryButton,
  Link,
  MessageBar,
  MessageBarType,
  Dropdown,
} from "office-ui-fabric-react";
import helpers from "../../helpers";
import { register } from "../../axios/auth";
import { connect } from "react-redux";

export class RegisterForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      msg: "",
      type: MessageBarType.error,

      fname: "",
      lname: "",
      accountType: "staff",
      securityQuestion: "what is the city of your birth?",
      securityAnswer: "",
      email: "",
      reEmail: "",
      password: "",
      rePassword: "",
    };
  }

  dismissMsg() {
    this.setState({
      msg: "",
    });
  }

  validateData() {
    const {
      email,
      reEmail,
      password,
      rePassword,
      fname,
      lname,
      securityAnswer,
    } = this.state;

    if (!fname) {
      return "Please enter your first name";
    }

    if (!lname) {
      return "Please enter your last name";
    }

    if (!email) {
      return "Email is not empty";
    }

    if (!helpers.validateEmail(email)) {
      return "Email is incorect";
    }

    if (email != reEmail) {
      return "Two different emails";
    }

    if (!password) {
      return "Password is not empty";
    }

    if (password.length < 6) {
      return "Password is too short";
    }

    if (password !== rePassword) {
      return "Two different password";
    }

    if (!securityAnswer) {
      return "Please enter your answer";
    }

    return "";
  }

  componentWillReceiveProps(newProps) {
    if (newProps.register.error) {
      this.setState({
        msg: newProps.register.error.message,
      });
    } else if (newProps.register.user) {
      this.setState({
        msg:
          "Please click on the link in your email to validate your registration",
        type: MessageBarType.success,
        fname: "",
        lname: "",
        accountType: "staff",
        securityQuestion: "what is the city of your birth?",
        securityAnswer: "",
        email: "",
        reEmail: "",
        password: "",
        rePassword: "",
      });

      this.props.onRegisted && this.props.onRegisted();
    }
  }

  handleRegister() {
    var msg = this.validateData();
    if (msg) {
      this.setState({
        msg,
        type: MessageBarType.error,
      });
      return;
    }
    const {
      fname,
      lname,
      accountType,
      securityQuestion,
      securityAnswer,
      email,
      password,
    } = this.state;
    var data = {
      firstName: fname,
      lastName: lname,
      securityQuestion: securityQuestion,
      securityAnswer: securityAnswer,
      emailAddress: email,
      password: password,
      accountType,
    };

    this.props.dispatch(register(data));
  }

  handleChange(fieldName, value) {
    var newState = {};
    newState[fieldName] = typeof value == "string" ? value : value.key;
    this.setState(newState);
  }

  render() {
    const { msg, type } = this.state;
    const {
      fname,
      lname,
      accountType,
      securityQuestion,
      securityAnswer,
      email,
      password,
      reEmail,
      rePassword,
    } = this.state;

    return (
      <div>
        {msg && type === MessageBarType.success && (
          <div style={{ marginBottom: 10 }}>
            <MessageBar
              messageBarType={MessageBarType.success}
              onDismiss={() => this.dismissMsg()}
            >
              {msg}
              <span>
                &nbsp;or&nbsp;<Link href="/user-login">Login</Link>
              </span>
            </MessageBar>
          </div>
        )}
        <TextField
          value={fname}
          onChanged={(v) => this.handleChange("fname", v)}
          label="First name"
          placeholder="First name"
          className="one-line-150"
        />
        <TextField
          value={lname}
          onChanged={(v) => this.handleChange("lname", v)}
          label="Last name"
          placeholder="Last name"
          className="one-line-150"
        />
        <div className="one-line-150">
          <Dropdown
            value={accountType}
            onChanged={(v) => this.handleChange("accountType", v)}
            label="Account type"
            options={accountTypes}
            selectedKey="staff"
          />
        </div>
        <TextField
          value={email}
          type="email"
          onChanged={(v) => this.handleChange("email", v)}
          label="Email Address"
          placeholder="Enter email address"
          className="one-line-150"
        />
        <TextField
          value={reEmail}
          type="email"
          onChanged={(v) => this.handleChange("reEmail", v)}
          label="Email - validation"
          placeholder="Re-enter email address"
          className="one-line-150"
        />
        <TextField
          value={password}
          onChanged={(v) => this.handleChange("password", v)}
          label="Password"
          type="password"
          placeholder="Enter password"
          className="one-line-150"
        />
        <TextField
          value={rePassword}
          onChanged={(v) => this.handleChange("rePassword", v)}
          label="Password - validation"
          type="password"
          placeholder="Re-enter password"
          className="one-line-150"
        />
        <div className="one-line-150">
          <Dropdown
            value={securityQuestion}
            onChanged={(v) => this.handleChange("securityQuestion", v)}
            label="Security question"
            options={securityQuestions}
            selectedKey="what is the city of your birth?"
          />
        </div>
        <TextField
          value={securityAnswer}
          onChanged={(v) => this.handleChange("securityAnswer", v)}
          label="Security answer"
          placeholder="Your answer"
          className="one-line-150"
        />
        {msg && type === MessageBarType.error && (
          <MessageBar
            messageBarType={MessageBarType.error}
            onDismiss={() => this.dismissMsg()}
          >
            {msg}
          </MessageBar>
        )}
        <div>
          <PrimaryButton className="mt-5" onClick={() => this.handleRegister()}>
            Register
          </PrimaryButton>
        </div>
      </div>
    );
  }
}

const accountTypeLabel = {
  staff: "Lead Generator",
  "central-user": "Central User",
  closer: "Closer",
  manager: "Manager",
  admin: "Admin",
};
const accountTypes = [
  "staff",
  "central-user",
  "closer",
  "manager",
  "admin",
].map((e) => ({ key: e, text: accountTypeLabel[e] }));

const securityQuestions = [
  "what is the city of your birth?",
  "what is your pet's name?",
].map((e) => ({ key: e, text: e.slice(0, 1).toUpperCase() + e.slice(1) }));

export default connect((state) => ({
  register: state.register,
}))(RegisterForm);



// WEBPACK FOOTER //
// ./client/components/common/RegisterForm.js